"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps } from "../../lib/inspector";
import { Counter, type CounterProps } from "./counter-section";

export type CounterInspectorProps = BlockInspectorProps;

export function CounterPreview(props: Readonly<CounterProps>) {
  const inspector = useContentfulInspectorMode();

  const items = props.items.map((item) => ({
    ...item,
    inspectorProps: {
      container:
        inspector({ fieldId: "internalName", entryId: item.sys?.id }) ??
        undefined,
    },
  }));

  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  return (
    <Counter
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
      }}
      items={items}
    />
  );
}
